import { Colors } from "../../../consts/Colors";
import ButtonRounded from "../../global/buttons/ButtonRounded";
import ButtonQ2 from "../ordi/ButtonQ2";
import QuestionPanel from "./QuestionPanel";
export default class QuestionPanel_2 extends QuestionPanel {
    constructor(scene, x, y, {config, totQuestion}) {
        super(scene, x, y, {
            numquestion: 2,
            totQuestion,
            question: config.question,
            soustitre: config.soustitre,
            textIndice: config.indice
        });

        // Ajout input
        let Y  = this.aideButton.y + this.aideButton.height/2 + 52

        // Ajout ligne
        let line = this.scene.add.rectangle(80 + 150, Y - 20, 1, 410, Colors.Elmt.DarkGrey).setOrigin(0)
        this.add(line)

        this.inputs = [];
        config.reponses.forEach( (reponse, index) => {
            let input = new ButtonQ2(this.scene, 80 + 230, Y, reponse.text, reponse.isTrue)
            this.inputs.push(input);
            this.add(input);
            Y+= input.height + 26
        })

        line.height = Y - line.y - 26

        // Ajout bouton valider
        this.validateButton = new ButtonRounded(this.scene, this.width /2, Y + 26, {
            text: "Valider vos réponses",
            color: Colors.Elmt.Orange,
            hoverColor: Colors.Elmt.Blue,
            textColor: Colors.Text.White,
        })
        this.add(this.validateButton)
        this.validateButton.y+= this.validateButton.height/2
        this.validateButton.setClickFunction( () => {
            this.validateButton.disableInteractive()
            // On bloque tous les éléments du panneau
            this.setLocked()

            // On vérifie la réponse
            this.scene.showReponsePopUp({
                text: config.correction,
                isTrue: this.isTrue(),
                endFunc: () => {
                    this.scene.closePanelQuestion((scene) => {scene.addQuestionPanel3();});
                    this.scene.closeReponsePopUp();
                }
            });
        })
    }

    setLocked(){
        super.setLocked();
        this.inputs.forEach(input => input.setLocked());
    }

    isTrue(){
        return this.inputs.every(input => input.isTrue());
    }
}